// Deterministic colour per tag string. Same tag → same colour everywhere.
// Palette is muted and dark-mode friendly; each entry supplies matching
// background / text / border classes so chips read as one thing.

const PALETTE = [
  { bg: 'bg-sky-500/20', text: 'text-sky-200', border: 'border-sky-700/60' },
  { bg: 'bg-emerald-500/20', text: 'text-emerald-200', border: 'border-emerald-700/60' },
  { bg: 'bg-amber-500/20', text: 'text-amber-200', border: 'border-amber-700/60' },
  { bg: 'bg-rose-500/20', text: 'text-rose-200', border: 'border-rose-700/60' },
  { bg: 'bg-violet-500/20', text: 'text-violet-200', border: 'border-violet-700/60' },
  { bg: 'bg-teal-500/20', text: 'text-teal-200', border: 'border-teal-700/60' },
  { bg: 'bg-fuchsia-500/20', text: 'text-fuchsia-200', border: 'border-fuchsia-700/60' },
  { bg: 'bg-lime-500/20', text: 'text-lime-200', border: 'border-lime-700/60' },
  { bg: 'bg-indigo-500/20', text: 'text-indigo-200', border: 'border-indigo-700/60' },
  { bg: 'bg-orange-500/20', text: 'text-orange-200', border: 'border-orange-700/60' },
  { bg: 'bg-cyan-500/20', text: 'text-cyan-200', border: 'border-cyan-700/60' },
  { bg: 'bg-pink-500/20', text: 'text-pink-200', border: 'border-pink-700/60' },
] as const;

// FNV-1a 32-bit — small, deterministic, case-insensitive.
function hash(input: string): number {
  let h = 0x811c9dc5;
  const s = input.toLowerCase();
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return h >>> 0;
}

export function tagChipClasses(tag: string, opts?: { active?: boolean }): string {
  const c = PALETTE[hash(tag) % PALETTE.length];
  if (opts?.active) {
    // Selected filter: solid ring so the "on" state is unambiguous.
    return `border ${c.border} ${c.bg} ${c.text} ring-2 ring-inset ring-white/40`;
  }
  return `border ${c.border} ${c.bg} ${c.text}`;
}
